import { useEffect, useState } from "react";

const manifestUrl = "/asset-manifest.json";
const mainRegex = /\/static\/js\/main\.[^/]+\.js$/;
const pollInterval = 60000;

export default function useVersionReload() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;

    const currentMain = Array.from(document.scripts)
      .map((s) => s.src)
      .find((src) => mainRegex.test(src));

    if (!currentMain) return;

    let active = true;
    let pollCount = 0;
    const check = async () => {
      try {
        pollCount += 1;
        if (pollCount % 2 === 0) {
          console.log("useVersionReload: check cycle");
        }

        const response = await fetch(manifestUrl, { cache: "no-cache" });
        if (!response.ok) {
          console.log("useVersionReload: manifest fetch failed", response.status);
          return;
        }
        const manifest = await response.json();
        const latestMain = new URL(manifest.files["main.js"], window.location.origin).href;
        if (active && latestMain !== currentMain) {
          console.log("useVersionReload: manifest changed", { currentMain, latestMain });
          setUpdateAvailable(true);
        }
      } catch (error) {
        console.log("useVersionReload: manifest check error", error);
      }
    };

    check();
    const id = window.setInterval(check, pollInterval);
    return () => {
      active = false;
      window.clearInterval(id);
    };
  }, []);

  return {
    updateAvailable,
    reloadPage: () => {
      window.location.reload();
    },
  };
}
